import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import style from '../../../style/components/profile/emails/SuspiciousDomainPrompt.module.scss';

const SuspiciousDomainPrompt = ({
  onContinue,
  onTryDifferent,
  isSubmitting,
  continueDisabled,
}) => {
  const { t } = useTranslation();

  return (
    <div className={style.alertContainer}>
      <div className={style.alertContent}>
        <div className={style.iconContainer}>
          <idme-icon name="alert-triangle" size="small" />
        </div>
        <div className={style.textContainer}>
          <div className={style.messageBlock}>
            <h3 className={style.alertTitle}>
              {t('walletEmails.suspiciousTitle')}
            </h3>
            <p className={style.alertBody}>
              {t('walletEmails.suspiciousBody')}
            </p>
          </div>
          <div className={style.actionGroup}>
            <button
              type="button"
              className={style.continueButton}
              onClick={onContinue}
              // `continueDisabled` covers the case where the addEmail attempt
              // failed with an errorCode the user can only resolve by editing
              // the address (e.g. VALIDATION_ERROR). The address input is not
              // present in this view, so the only path forward is "Try a
              // different email" — leave that one enabled.
              disabled={isSubmitting || continueDisabled}
            >
              {isSubmitting
                ? t('walletEmails.addEmailSubmitting')
                : t('walletEmails.suspiciousContinue')}
            </button>
            <button
              className={style.textLink}
              onClick={onTryDifferent}
              type="button"
              disabled={isSubmitting}
              aria-label={t('walletEmails.suspiciousTryDifferent')}
            >
              {t('walletEmails.suspiciousTryDifferent')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

SuspiciousDomainPrompt.propTypes = {
  onContinue: PropTypes.func.isRequired,
  onTryDifferent: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
  continueDisabled: PropTypes.bool,
};

SuspiciousDomainPrompt.defaultProps = {
  isSubmitting: false,
  continueDisabled: false,
};

export default memo(SuspiciousDomainPrompt);
